(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["certificates-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sectionEls = document.querySelectorAll('.dfh-certs');
    if (!sectionEls.length) return;
 
    // ---- Modal yönetimi ----
    document.querySelectorAll('.js-dfh-open').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var pdf = btn.getAttribute('data-pdf');
        var title = btn.getAttribute('data-title') || 'Sertifika';
        if (!pdf) return;
 
        var section = btn.closest('.dfh-certs');
        var modal = section && section.nextElementSibling;
        while (modal && !modal.classList.contains('dfh-modal')) {
          modal = modal.nextElementSibling;
        }
        if (!modal) return;
 
        var frame = modal.querySelector('iframe');
        var titleEl = modal.querySelector('.dfh-modal__title');
        var openLink = modal.querySelector('.dfh-modal__open');
 
        frame.setAttribute('src', pdf + '#view=FitH');
        titleEl.textContent = title;
        openLink.setAttribute('href', pdf);
 
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    });
 
    document.querySelectorAll('.dfh-modal').forEach(function (modal) {
      function close() {
        modal.setAttribute('aria-hidden', 'true');
        var frame = modal.querySelector('iframe');
        if (frame) frame.setAttribute('src', '');
        document.body.style.overflow = '';
      }
      modal.querySelectorAll('.js-dfh-close').forEach(function (el) {
        el.addEventListener('click', close);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') close();
      });
    });
 
    // ---- PDF.js ile thumbnail render (cache'li, lazy) ----
    var canvases = document.querySelectorAll('.js-dfh-thumb');
    if (!canvases.length) return;
 
    var PDFJS_VER = '3.11.174';
    var PDFJS_BASE = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/' + PDFJS_VER;
    var CACHE_PREFIX = 'dfh-pdf-thumb:v2:';
    var pdfJsPromise = null;
 
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var existing = document.querySelector('script[data-src="' + src + '"]');
        if (existing) { resolve(); return; }
        var s = document.createElement('script');
        s.src = src;
        s.async = true;
        s.dataset.src = src;
        s.onload = resolve;
        s.onerror = reject;
        document.head.appendChild(s);
      });
    }
 
    function ensurePdfJs() {
      if (window.pdfjsLib) return Promise.resolve();
      if (pdfJsPromise) return pdfJsPromise;
      pdfJsPromise = loadScript(PDFJS_BASE + '/pdf.min.js').then(function () {
        if (window.pdfjsLib) {
          window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_BASE + '/pdf.worker.min.js';
        }
      });
      return pdfJsPromise;
    }
 
    function cacheKey(url) { return CACHE_PREFIX + url; }
 
    function loadFromCache(canvas) {
      var url = canvas.getAttribute('data-pdf');
      try {
        var data = localStorage.getItem(cacheKey(url));
        if (!data) return false;
        var img = new Image();
        img.onload = function () {
          var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          canvas.style.width = (img.naturalWidth / dpr) + 'px';
          canvas.style.height = (img.naturalHeight / dpr) + 'px';
          canvas.getContext('2d').drawImage(img, 0, 0);
          canvas.classList.add('is-loaded');
        };
        img.src = data;
        return true;
      } catch (e) { return false; }
    }
 
    function saveToCache(canvas) {
      try {
        var url = canvas.getAttribute('data-pdf');
        var data = canvas.toDataURL('image/jpeg', 0.72);
        localStorage.setItem(cacheKey(url), data);
      } catch (e) {
        // Quota dolduysa eski thumb cache'lerini temizle
        try {
          var keys = [];
          for (var i = 0; i < localStorage.length; i++) {
            var k = localStorage.key(i);
            if (k && k.indexOf(CACHE_PREFIX) === 0) keys.push(k);
          }
          keys.forEach(function (k) { localStorage.removeItem(k); });
        } catch (e2) {}
      }
    }
 
    function renderThumb(canvas) {
      var url = canvas.getAttribute('data-pdf');
      if (!url || !window.pdfjsLib) return;
 
      var task = window.pdfjsLib.getDocument({
        url: url,
        rangeChunkSize: 65536,
        disableAutoFetch: false,
        disableStream: false,
        isEvalSupported: false
      });
 
      task.promise
        .then(function (pdf) { return pdf.getPage(1); })
        .then(function (page) {
          var container = canvas.parentElement;
          var maxW = container.clientWidth || 300;
          var maxH = container.clientHeight || 400;
 
          var unscaled = page.getViewport({ scale: 1 });
          var fit = Math.min(maxW / unscaled.width, maxH / unscaled.height);
          // Thumbnail için 1.4x DPR yeterli — full retina yerine hızlı
          var dpr = Math.min(window.devicePixelRatio || 1, 1.4);
          var viewport = page.getViewport({ scale: fit * dpr });
 
          canvas.width = viewport.width;
          canvas.height = viewport.height;
          canvas.style.width = (viewport.width / dpr) + 'px';
          canvas.style.height = (viewport.height / dpr) + 'px';
 
          return page.render({
            canvasContext: canvas.getContext('2d'),
            viewport: viewport,
            intent: 'display'
          }).promise;
        })
        .then(function () {
          canvas.classList.add('is-loaded');
          // Render bittikten sonra cache'e at (sıradaki kartı bloklamasın)
          if (window.requestIdleCallback) {
            requestIdleCallback(function () { saveToCache(canvas); });
          } else {
            setTimeout(function () { saveToCache(canvas); }, 100);
          }
        })
        .catch(function () {
          var skel = canvas.nextElementSibling;
          if (skel) skel.style.display = 'none';
        });
    }
 
    function processCanvas(canvas) {
      // Önce cache'ten dene — varsa anında görünür
      if (loadFromCache(canvas)) return;
      // Yoksa PDF.js'in yüklenmesini bekle ve render et
      ensurePdfJs().then(function () { renderThumb(canvas); });
    }
 
    // PDF.js'i sayfa açılır açılmaz arka planda yüklemeye başla
    // (kart ekrana girdiğinde kütüphane zaten hazır olur)
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function () { ensurePdfJs(); }, { timeout: 1500 });
    } else {
      setTimeout(function () { ensurePdfJs(); }, 300);
    }
 
    var observer = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var canvas = entry.target;
          observer.unobserve(canvas);
          processCanvas(canvas);
        }
      });
    }, { rootMargin: '400px' }) : null;
 
    if (observer) {
      canvases.forEach(function (c) { observer.observe(c); });
    } else {
      canvases.forEach(function (c) { processCanvas(c); });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
